import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { TextInputRootBase } from "./TextInputRootBase";
import { formInputTheme, getBorderColor } from "./formInputTheme";
export var TextInputRootUnderline = styled(TextInputRootBase)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    border: ", "px solid transparent;\n    border-bottom: solid ", ";\n    border-width: ", "px;\n    border-radius: ", "px;\n    background-color: ", ";\n    border-left-width: 0;\n    border-right-width: 0;\n    border-radius: 0;\n"])), function (props) {
  return props.themeMode === "oldestar" ? 1 : 2;
}, getBorderColor, function (props) {
  return props.validationState === "error" ? formInputTheme.borderWidth.error(props.themeMode) : formInputTheme.borderWidth.rest(props.themeMode);
}, function (props) {
  return props.themeMode === "oldestar" ? 2 : 4;
}, getBackgroundColor);
function getBackgroundColor(_ref) {
  var isDisabled = _ref.isDisabled,
    themeMode = _ref.themeMode;
  if (isDisabled) {
    return formInputTheme.backgroundColor.readonly(themeMode);
  } else {
    return formInputTheme.backgroundColor.underlined(themeMode);
  }
}
//# sourceMappingURL=TextInputRootUnderline.js.map